import React, { Fragment, useEffect } from 'react';
import NewNavbar from '../../new-components/NewNavbar';
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides';
import NewDesignSystem from '../../new-components/NewDesignSystem';
import CoupleSection2 from '../../components/CoupleSection2';
import PortfolioSection from '../../components/PortfolioSection';
import NewFooter from '../../new-components/NewFooter';
import NewMadeWith from '../../new-components/NewMadeWith';
import NewScrollTop from '../../new-components/NewScrollTop';
import StorySection from '../../components/StorySection';
import PartnerSection from '../../components/PartnerSection';

const StoryPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <CoupleSection2 />
      <StorySection />
      <PortfolioSection pSclass={'pt-0'} />
      <PartnerSection tNone={'pb-120'} />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};
export default StoryPage;
